import { ReactComponent as OutlineCross } from "assets/svg/outline-cross.svg";
import { ReactComponent as OutlineNewscreen } from "assets/svg/outline-newscreen.svg";
import { ReactComponent as OutlineTrash1 } from "assets/svg/outline-trash-1.svg";
import { ReactComponent as OutlineEdit1 } from "assets/svg/outline-edit-1.svg";
import IconButton from "components/icon-button";
import type { MouseEvent, ReactNode } from "react";
import styles from "./SidesheetHeader.module.scss";
import getClasses from "utils/getClasses";

type Props = {
  title: ReactNode;
  className?: string;
  typeIndicatorClassName?: string;
  onExpand?: (e?: MouseEvent<HTMLElement>) => void;
  onClose?: (e?: MouseEvent<HTMLElement>) => void;
  onDelete?: (e?: MouseEvent<HTMLElement>) => void;
  onEdit?: (e?: MouseEvent<HTMLElement>) => void;
};
const SidesheetHeader = ({
  title,
  className,
  typeIndicatorClassName,
  onExpand,
  onClose,
  onDelete,
  onEdit,
}: Props) => (
  <div className={getClasses(styles["container"], className)}>
    <div
      className={getClasses(styles["type-indicator"], typeIndicatorClassName)}
    />
    <div className={styles["content"]}>
      <span className={styles["title"]}>{title}</span>
      {onExpand && (
        <IconButton className={styles["button"]} onClick={onExpand}>
          <OutlineNewscreen />
        </IconButton>
      )}
      {onEdit && (
        <IconButton className={styles["button"]} onClick={onEdit}>
          <OutlineEdit1 />
        </IconButton>
      )}
      {onDelete && (
        <IconButton className={styles["button"]} onClick={onDelete}>
          <OutlineTrash1 />
        </IconButton>
      )}
      {onClose && (
        <IconButton className={styles["button"]} onClick={onClose}>
          <OutlineCross />
        </IconButton>
      )}
    </div>
  </div>
);

export default SidesheetHeader;
